import { gql } from '@apollo/client';

export const GET_GEOIP = gql`
  query geoIp {
    geoIp {
      hasAcceptedCookies
    }
  }
`;
